<template>
  <teleport to="body">
    <ModalBase
      :show="modalActive"
      hide-submit
      hide-cancel
      min-width="50vw"
      :title="$t('reserva.gestionarPago')"
      @on-close="close">
      <template #body>
        <MisReservasPago :grupo="grupo" style="width: 1000px" @close-modal="close" />
      </template>
    </ModalBase>
  </teleport>
</template>

<script setup>
  import ModalBase from '@/components/modales/ModalBase.vue';
  import MisReservasPago from '@/components/modales/MisReservasPago.vue';

  defineProps({
    grupo: {
      type: Object,
      default: null,
    },
    modalActive: {
      type: Boolean,
      default: null,
    },
  });

  const emit = defineEmits(['close-modal']);

  function close() {
    emit('close-modal');
  }
</script>

<style lang="css"></style>
